import * as React from "react"
const Search = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={31}
    height={31}
    fill="none"
    {...props}
  >
    <path
      fill="#000"
      d="M20.02 18.083H19l-.361-.348a8.359 8.359 0 0 0 2.028-5.464 8.395 8.395 0 1 0-8.396 8.396c2.08 0 3.991-.762 5.464-2.028l.348.361v1.02l6.459 6.446 1.924-1.924-6.445-6.459Zm-7.75 0a5.805 5.805 0 0 1-5.812-5.812 5.805 5.805 0 0 1 5.813-5.813 5.805 5.805 0 0 1 5.812 5.813 5.805 5.805 0 0 1-5.812 5.812Z"
    />
  </svg>
)
export default Search